$(document).on('click', 'div:not(.advanced-placeholder-replacer) > .placeholder', function () {
    let selector = $(this).parent().data('selector');

    // Detect if Jquery variant is passed, for dynamic translation fields
    if (selector.charAt(0) === '$') {
        selector = eval(selector);
    } else {
        selector = $(selector)
    }

    insertPlaceholder(selector, placeholder)
});

function registerClickEventSingle(component, selector) {
    component.find('.placeholder').on('click', function () {
        insertPlaceholder(selector, $(this).data('placeholder'))
    });
}

function insertPlaceholder(input, placeholder) {
    // For normal input types
    if (!input[0].classList.contains('ckeditor-initialised')) {
        input.insertAtCaret(placeholder);
        return;
    }

    let editor = input[0].ckeditor
    editor.model.change(writer => {
        const insertPosition = editor.model.document.selection.getFirstPosition();
        editor.model.insertContent(writer.createText(placeholder), insertPosition);
    });
}


window.initializeAdvancedReplacer = function () {
    $(document).find('.advanced-placeholder-replacer:not(.initialized)').each(function () {
        this.classList.add('initialized');
        let placeholdersComponent = $(this);
        let elementsToWatch = $($(this).data('selector')).filter(':not(.exclude-for-replacer)');

        if (elementsToWatch.length === 0) {
            return;
        }

        if (elementsToWatch.length === 1) {
            registerClickEventSingle(placeholdersComponent, elementsToWatch);
        }


        let activeElement = elementsToWatch.first();

        setTimeout(() => {
            elementsToWatch.each(function () {
                // check if element is a ckeditor
                if (!this.classList.contains('ckeditor-initialised')) {
                    $(this).on('click keyup', function () {
                        activeElement = $(this);
                    });
                    return;
                }

                $(this).parent().find('.ck-editor').on('click', () => {
                    activeElement = $(this);
                });
            });
        });

        placeholdersComponent.find('.placeholder').click(function () {
            // check if active element is visible
            if (activeElement.is(':visible')) {
                insertPlaceholder(activeElement, $(this).data('placeholder'))
                return;
            }

            // Check if ckeditor visible
            if (activeElement.is('.ckeditor-initialised') && activeElement.parent().find('.ck-editor').is(':visible')) {
                insertPlaceholder(activeElement, $(this).data('placeholder'))
                return;
            }

            // find the first visible element
            activeElement = elementsToWatch.filter(':visible').first();
            insertPlaceholder(activeElement, $(this).data('placeholder'))
        });

        placeholdersComponent.find('.placeholders-search-input').on('keyup', function () {
            let search = $(this).val().toLowerCase();

            placeholdersComponent.find('.placeholder').each(function () {
                let placeholder = $(this).data('placeholder').toLowerCase() + this.innerText.toLowerCase();
                if (placeholder.includes(search)) {
                    $(this).removeClass('ani-shrink-fast');
                } else {
                    $(this).addClass('ani-shrink-fast');
                }
            });
        });
    });
};